<template>
    <div class='invoice-overview-page-container'>
        <div class='content-container'>
            <div class='filter-container'>
                <label>Filtern</label>
                <DateInput label='Datum' v-model='filter.from'/>
                <TextInput label='Nummer' v-model='filter.nr'/>
            </div>
            <div class="invoices-container">
                <div class="total-balance">
                    <label>Kontostand:</label>
                    <span class="balance" :class="{ 'red': totalBalance > 0 }">
                        <label v-if="totalBalance > 0">-{{ util.formatCurrency(totalBalance) }} €</label>
                        <label v-else>{{ util.formatCurrency(totalBalance) }} €</label>
                    </span>
                </div>
                <div class='invoices-header'>
                        <label class="width-large align-left">Nummer</label>
                        <label class="width-medium align-center">Datum</label>
                        <label class="width-medium align-center">Gesamtbetrag</label>
                        <label class="width-medium align-right">Restbetrag</label>
                </div>

                <div class="content-divider"></div>
                <div class="invoice-table">
                    <div class='invoice' v-for='(invoice, idx) in filteredInvoices' :key='idx'>
                        <div class='entry width-large align-left'>
                            <label class="entry-value">{{ invoice.invoiceNr }}</label>
                        </div>
                        <div class='entry width-medium align-center'>
                            <label class="entry-value">{{ invoice.date }}</label>
                        </div>
                        <div class='entry width-medium align-center'>
                            <label class="entry-value">{{  util.formatCurrency(invoice.amount) }}€</label>
                        </div>
                        <div class='entry width-large'>
                            <div class="number-download">
                                <label class="entry-value">{{  util.formatCurrency(invoice.balance) }}€</label>
                                <img src='@img/print-solid.svg' @click="handleDownloadInvoice(invoice)"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import TextInput from '@components/elements/TextInput.vue'
import DateInput from '@components/elements/DateInput.vue'

export default {
    name: 'invoice-overview-page',
    inject: [ 'util', 'globalState', 'toast' ],
    data() { 
        return {
            filter: {
                from: undefined,
                nr: ''
            },
            invoices: []
        }
    },
    mounted() {
        this.getInvoices()
    },
    computed: {
        customerNr() {
            return this.globalState.customer.customerNr
        },
        filteredInvoices() {
            if (!this.invoices || this.invoices.length < 1) {
                return []
            }

            return this.invoices.filter(invoice => {
                const invoiceDateParts = invoice.date.match(/(\d+)/g)
                const invoiceDate = new Date(invoiceDateParts[2], invoiceDateParts[1]-1, invoiceDateParts[0])

                const nrHit   = !this.filter.nr   || invoice.invoiceNr.toLowerCase().includes(this.filter.nr.toLowerCase())
                const dateHit = !this.filter.from || this.util.isSameDate(invoiceDate, this.filter.from)

                return nrHit && dateHit
            })
        },
        totalBalance() {
            if (!this.invoices || this.invoices.length < 1) {
                return undefined
            }
            return this.invoices.reduce((acc, currVal) => acc + currVal.balance, 0)
        }
    },
    methods: {
        getInvoices() {
            this.globalState.isLoading = true

            let getInvoiceUrl = this.util.middleware()
            getInvoiceUrl += '/customers/' + this.customerNr
            getInvoiceUrl += '/invoices'

            axios.get(getInvoiceUrl)
            .then(response => {
                this.invoices = response.data
                this.globalState.isLoading = false
            })
            .catch(() => { 
                const errorMessage = this.$t('invoice.download-error')
                this.toast.error(errorMessage)
            })
        },
        async downloadInvoice (customerNr, invoiceId) {

            let printUrl = this.util.middleware()
            printUrl += '/customers/' + customerNr
            printUrl += '/invoices/' + invoiceId
            printUrl += '/print'

            return axios.get(printUrl)
            .then(response => {
                    this.globalState.isLoading = false
                    return response.data
                }
            )
            .catch(err => {
                this.globalState.isLoading = false
                throw err
            })
        },
        async handleDownloadInvoice (invoice) {
            this.globalState.isLoading = true

            try{
                const documentDataUri = await this.downloadInvoice(this.customerNr, invoice.id)
                const fileUrl = await this.util.convertDataUriToFile(documentDataUri)

                this.globalState.isLoading = false

                window.open(fileUrl, '_blank')

            } catch {
                const errorMessage = this.$t('invoice.download-error')
                this.toast.error(errorMessage)
            }

        }
    },
    components: {
        TextInput,
        DateInput
    }
}
</script>

<style lang='scss' scoped>
.invoice-overview-page-container {
    overflow-y: hidden;
    max-height: 90%;

    > .content-container {
        max-height: 100%;
        display: flex;
        flex-direction: column;

        > .filter-container {
            margin-top: 20px;
            background-color: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 8px #00000022;
            padding: 16px;
            display: flex;
            align-items: center;
            height: fit-content;
            flex-wrap: wrap;

            > label {
                font-size: 1.5em;
            }

            > .input-wrapper {
                margin-left: 16px;
            }
        }

        > .invoices-container{
            margin-top: 20px;
            margin-bottom: 10px;
            background-color: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 8px #00000022;
            padding: 1.5rem;
            overflow: hidden;
            display: flex;
            flex-direction: column;

            > .total-balance {
                font-size: 1.2rem;
                min-width: 80px;
                padding-right: 3rem;
                display: flex;
                justify-content: flex-end;

                > .balance {
                    > label {
                        padding-left: 0.8rem;
                    }
                    &.red {
                        color: red;
                    }
                }
            }

            > .invoices-header {
                width: 100%;
                display: flex;
                // justify-content: space-between;
                margin-top: 3rem;
                padding-left: 2rem;
                padding-right: 5rem;
                gap: 10rem;

                > label {
                    font-size: 1.2em;
                    font-weight: bold;

                    &.width-large {
                        min-width: 130px;
                    }
                    &.width-medium {
                        min-width: 100px;
                    }
                    &.align-left {
                        text-align: left;
                    }
                    &.align-center{
                        text-align: center;
                    }
                    &.align-right {
                        text-align: right;
                    }
                }
            }

            > .content-divider {
                margin: 0;
                border: 0.5px solid #bbc0c6;
                margin-top: 0.8rem;
            }

            > .invoice-table{
                overflow-y: scroll;
                > .invoice {
                    margin-top: 20px;
                    background-color: #fff;
                    border-radius: 8px;
                    box-shadow: 0 2px 8px #00000022;
                    border-bottom: 1px solid #ccc;
                    padding: 1.5rem;
                    padding-right: 5rem;
                    display: flex;
                    gap: 10rem;

                    > .entry {
                        &.width-large {
                            min-width: 130px;
                        }
                        &.width-medium {
                            min-width: 100px;
                        }
                        &.align-left {
                            text-align: left;
                        }
                        &.align-center{
                            text-align: center;
                        }
                        &.align-right {
                            text-align: right;
                        }

                        >.number-download {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            gap: 2rem;

                            > .entry-value {
                                flex-grow: 1;
                                text-align: center;
                            }

                            > img {
                                width: 10%;
                                height: 10%;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }
    }
}

@media(max-width: 575px) {
    .invoice-overview-page-container {
        > .content-container {
            > .invoices-container {
                > .invoices-header {
                    display: none;
                }
                .invoice-table {
                    >.invoice{
                        >.entry{
                            display: none;
                        }
                    }
                }
            }
        }
    }
}
</style>